import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import CountryCMSModel from '@/visa-application/models/CountryCMSModel';

export interface Carousel {
  link: string;
  imgLink: string;
}
export default class SplashCMSModel implements CMSModel {
  country: CountryCMSModel = new CountryCMSModel();
  available_appointment_table_power_switch: boolean;
  welcome_header: string;
  welcome_content: string;
  splash_header: string;
  splash_content: string;
  splash_content_color: string;
  table_header: string;
  table_tourism: string;
  table_business: string;
  table_others: string;
  meta_title = '';
  meta_description = '';
  meta_keywords = '';
  swipeAutoplayTime = 0;
  carousel: Carousel[] = [];
  carousel_mobile: Carousel[] = [];
  table_info: string;

  map(obj: any): void {
    this.country.map(_.get(obj, 'country', {}));
    this.available_appointment_table_power_switch = _.get(obj, 'available_appointment_table_power_switch', false);
    this.welcome_header = _.get(obj, 'translation[0].welcome_header', '');
    this.welcome_content = _.get(obj, 'translation[0].welcome_content', '');
    this.splash_header = _.get(obj, 'translation[0].splash_header', '');
    this.splash_content = _.get(obj, 'translation[0].splash_content', '');
    this.splash_content_color = _.get(obj, 'translation[0].splash_content_color', '');
    this.table_header = _.get(obj, 'translation[0].table_header', '');
    this.table_tourism = _.get(obj, 'translation[0].table_tourism', '');
    this.table_business = _.get(obj, 'translation[0].table_business', '');
    this.table_others = _.get(obj, 'translation[0].table_others', '');
    this.meta_title = _.get(obj, 'translation[0].meta_title', '');
    this.meta_description = _.get(obj, 'translation[0].meta_description', '');
    this.meta_keywords = _.get(obj, 'translation[0].meta_keywords', '');
    this.swipeAutoplayTime = _.get(obj, 'swipe_autoplay_time', 0);
    this.carousel = _.get(obj, 'translation[0].carousel', '');
    this.carousel_mobile = _.get(obj, 'translation[0].carousel_mobile', '');
    this.table_info = _.get(obj, 'translation[0].table_info', '');
  }
}
